import classNames from 'classnames';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';
import './styles.css';
import ArrowLeftIcon from '../../UI/icons/ArrowLeft';

const Pane = ({ className, children, show, onClose, footer, rtl = false, size = 'lg' }) => {
  const ref = useRef(null);
  const backdropRef = useRef(null);
  const [render, setRender] = useState(false);

  const close = useCallback((cancel = false) => {
    if (ref.current) {
      ref.current.animate([
        { transform: 'translateX(0)' },
        { transform: rtl ? 'translateX(-100%)' : 'translateX(100%)' },
      ], {
        duration: 300,
        easing: 'ease-in-out',
        fill: 'forwards',
      }).onfinish = () => {
        setRender(false);
        onClose(false, cancel);
      };

      backdropRef.current.animate([
        { opacity: 1 },
        { opacity: 0 },
      ], {
        duration: 300,
        easing: 'ease-in-out',
        fill: 'forwards',
      });
    }
  }, [onClose, rtl]);

  const open = useCallback(() => {
    if (ref.current) {
      ref.current.animate([
        { transform: rtl ? 'translateX(-100%)' : 'translateX(100%)' },
        { transform: 'translateX(0)' },
      ], {
        duration: 300,
        easing: 'ease-in-out',
        fill: 'forwards',
      });

      backdropRef.current.animate([
        { opacity: 0 },
        { opacity: 1 },
      ], {
        duration: 300,
        easing: 'ease-in-out',
        fill: 'forwards',
      });
    }
  }, [rtl]);

  useEffect(() => {
    if (show) {
      setRender(true);
    } else {
      close();
    }
  }, [close, show]);

  useEffect(() => {
    if (render && ref.current) {
      open();
    }
  }, [open, render]);

  return (
    <>
      {render && createPortal((
        <div className={classNames(
          'pane',
          `pane--${size}`,
          {
            'pane--rtl': rtl,
          },
          className
        )}>
          <button ref={backdropRef} type={'button'} className={'pane__backdrop'} aria-label={'Close'} onClick={() => close(true)} />
          <div ref={ref} className={'pane__content'}>
            <div className={'pane__header'}>
              <button type={'button'} className={'pane__close'} onClick={() => close(true)}>
                <ArrowLeftIcon size={24} />
              </button>
            </div>
            <div className={'pane__content-inner'}>
              {children}
            </div>
            {!!footer && (
              <div className={'pane__footer'}>{footer}</div>
            )}
          </div>
        </div>
      ), document.body)}
    </>
  );
}

export default Pane;
